export default __webpack_public_path__ + "static/media/1894.ce17381e.png";